export const bonusBenefitStyles = 'items-center';
//# sourceMappingURL=bonusBenefitStyles.js.map